import React from "react";
import { Toast, ToastContainer } from "react-bootstrap";
import {
  CheckCircleFill,
  XCircleFill,
  ExclamationTriangleFill,
  InfoCircleFill,
  X,
} from "react-bootstrap-icons";
import "./CustomToast.css";

const CustomToast = ({
  show,
  onClose,
  message,
  variant = "success", // success, error, warning, info
  position = "bottom-end",
  delay = 4000,
  autohide = true, // Changed to false for debugging
  isMobile = false,
}) => {
  // Define colors and icons based on variant
  const getVariantStyles = (variant) => {
    switch (variant) {
      case "success":
        return {
          backgroundColor: "rgba(0, 0, 0, 0.9)",
          color: "white",
          iconColor: "#28a745",
          IconComponent: CheckCircleFill,
        };
      case "error":
        return {
          backgroundColor: "rgba(0, 0, 0, 0.9)",
          color: "white",
          iconColor: "#dc3545",
          IconComponent: XCircleFill,
        };
      case "warning":
        return {
          backgroundColor: "rgba(255, 193, 7, 0.9)",
          color: "black",
          iconColor: "#ffc107",
          IconComponent: ExclamationTriangleFill,
        };
      case "info":
        return {
          backgroundColor: "rgba(13, 202, 240, 0.9)",
          color: "white",
          iconColor: "#17a2b8",
          IconComponent: InfoCircleFill,
        };
      default:
        return {
          backgroundColor: "rgba(0, 0, 0, 0.9)",
          color: "white",
          iconColor: "#6c757d",
          IconComponent: InfoCircleFill,
        };
    }
  };

  const variantStyles = getVariantStyles(variant);
  const IconComponent = variantStyles.IconComponent;

  return (
    <ToastContainer
      position={isMobile ? "top-center" : position}
      style={{
        position: "fixed",
        zIndex: 9999,
        ...(isMobile && {
          top: "20px",
          left: "50%",
          transform: "translateX(-50%)",
        }),
      }}
      className={`custom-toast-container ${isMobile ? "mobile-toast" : ""}`}
    >
      <Toast
        show={show}
        onClose={onClose}
        delay={delay}
        autohide={autohide}
        style={{
          backgroundColor: variantStyles.backgroundColor,
          color: variantStyles.color,
          border: "none",
          minWidth: "300px",
        }}
      >
        <Toast.Body style={{ color: variantStyles.color }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <IconComponent
              size={16}
              color={variantStyles.iconColor}
              style={{ flexShrink: 0 }}
            />
            <span style={{ flex: 1 }}>{message}</span>
            {!autohide && (
              <button
                type="button"
                onClick={onClose}
                style={{
                  background: "none",
                  border: "none",
                  color: variantStyles.color,
                  cursor: "pointer",
                  padding: "0",
                  marginLeft: "8px",
                  display: "flex",
                  alignItems: "center",
                  opacity: 0.7,
                }}
                onMouseEnter={(e) => (e.target.style.opacity = "1")}
                onMouseLeave={(e) => (e.target.style.opacity = "0.7")}
                aria-label="Close"
              >
                <X size={16} />
              </button>
            )}
          </div>
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default CustomToast;
